var jquery = require('jquery');
Vue.prototype.$ = jquery;
require('bootstrap');

import Vue from 'vue'

import axios from 'axios'
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.prototype.$axios = axios

// **********************************************************************************************************************

import loadash from 'lodash';
Vue.prototype.$_ = loadash;

// **********************************************************************************************************************

import VueRouter from 'vue-router';
import { routes } from "./routes";
Vue.use(VueRouter);

Vue.prototype.$Fire = new Vue();

import store from './store'
// ***********************************************************
import Vuetify from 'vuetify';

// import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
Vue.use(Vuetify);
const vuetify = new Vuetify({
    theme: {
        dark: true,
        themes: {
            light: {
                primary: '#4682B4',
                success: '#2d8831',
                info: '#708090',
                error: '#bd3030',
                warning: '#F4A460',
                secondary: '#b0bec5',
                anchor: '#2F4F4F',
                dt_table: '#efeeee',

                c_scroll_thumb: '#4682B4',
                c_scroll_thumb_hover: '#708090',
                c_scroll_track: '#bfbfbf',
                c_headline_bg: '#696767',
            },
            dark: {
                primary: '#ffffff',
                success: '#d4af37',
                info: '#950101',
                error: '#ffc1b5',
                warning: '#F4A460',
                secondary: '#203864',
                anchor: '#2F4F4F',
                dt_table: '#817D62',


                c_scroll_thumb: '#FFFFFF',
                c_scroll_thumb_hover: '#FFFFFF',
                c_scroll_track: '#FFFFFF',
                c_headline_bg: '#FFFFFF',

                menu: '#243448',


                // background: 'rgb(34 33 33)',
                // custom_bg_menu: 'rgb(34 33 33)',
                background: '#000000',
                custom_bg_menu: '#1f1f1f',

                custom_bg_search: '#950101',
                dashboard_boxes: '#1f1f1f',
                login_button: '#950101',
                custom_info: '#950101',
                custom_success: '#009933',
                custom_error: '#3D0000',
                breadcrumb_color: '#FFFFFF',

                green_button: '#950101',
                red_button: '#3D0000',
                delete_button: '#d84a1e',

                tbl_header: '#017996',
                dialog_header_footer: '#152e5d',
                login_container_bg: '#000000',
                copyright_container_bg: '#1f1f1f',
            },
        },
        options: { customProperties: true },
    },
    icons: {
        iconfont: 'mdi',
    },
});
export default vuetify;
// **********************************************************************************************************************

import { Form } from 'vform';
// Vue.component(HasError.name, HasError)
// Vue.component(AlertError.name, AlertError)
Vue.prototype.$Form = Form
// Vue.prototype.Form = Form
// window.Form = Form;

// **********************************************************************************************************************

import moment from 'moment';
Vue.prototype.$moment = moment;

// **********************************************************************************************************************

import Swal from 'sweetalert2';
Vue.prototype.$Swal = Swal;
const toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    closeButtonHtml: '&times;',
    showCloseButton: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

const toast_status = Swal.mixin({
    toast: true,
    position: 'bottom-left',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    closeButtonHtml: '&times;',
    showCloseButton: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

Vue.prototype.$toast = toast;
Vue.prototype.$toast_status = toast_status;

// **********************************************************************************************************************
import CKEditor from 'ckeditor4-vue';
Vue.use(CKEditor);
Vue.prototype.$ckEditorConfig = {
    // width: '100%',
    // height: '250px',
    resize_enabled: false,
    extraPlugins: 'autogrow',
    autoGrow_minHeight: 250,
    autoGrow_maxHeight: 600,
    removeButtons: 'About,Styles,Table,Maximize',
};
// ***********************************************************
Vue.prototype.$goldCoinDark = "images/mrm_logos/Sapphire-150x150.png";
Vue.prototype.$goldCoinWhite = "images/mrm_logos/Sapphire-150x150.png";
Vue.prototype.$avatarGold = "images/mrm_logos/Player-Manager-Gold-300x300.png";
Vue.prototype.$goldCoinPile = "images/mrm_logos/Sapphire-150x150.png";

Vue.prototype.$dashboardCoin = "images/mrm_logos/Sapphire-150x150.png";
Vue.prototype.$siteLogoSmall = "images/GreenBitcoinV2/BC-500x500.png";

Vue.prototype.$siteLogo = "images/GreenBitcoinV2/BC-500x500.png";
Vue.prototype.$loginPlaynow = "images/play_now_v2.png";

Vue.prototype.$goldCoinCashIn = "images/Cash-in.png";
Vue.prototype.$goldCoinCashOut = "images/Cash-out.png";

Vue.prototype.$gold_coin_lg = 25;
Vue.prototype.$gold_coin_sm = 20;
// ***********************************************************

// CALL FILTER INSIDE METHOD
// this.$options.filters.decodeEntities(data.template);

Vue.filter('setDate', function (date) {
    return moment(date).format('MMMM DD, YYYY');
});

Vue.filter('timeFilter', function (boothTime) {
    return moment(boothTime, ["h:mm A"]).format('h:mm a');
});

Vue.filter('datetime', function (date) {
    return moment(date).format('MMM. DD, YYYY h:mm a');
});

// Vue.filter('timeFilter', function(boothTime) {
//     return moment(boothTime, ["h:mm A"]).format('h:mm a');
// });

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('zh-CN', {
        style: 'currency',
        currency: 'Php'
    });
    return formatter.format(value);
});

Vue.filter('toNumberWithDecimal', function (value) {
    if (typeof value !== "number") {
        return '0.00';
    }
    var formatter = new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 2 });
    return formatter.format(value);
});
Vue.filter('toCoin', function (value) {
    const options = { minimumFractionDigits: 2 }
    return new Intl.NumberFormat('zh-CN', options).format(value);
});

Vue.filter('decodeEntities', function (value) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = value;
    return textArea.value;
});

Vue.filter('toHTML', function (value) {
    var temp = document.createElement('div');
    temp.innerHTML = value;
    console.log(temp.firstChild);
    return temp.firstChild;
});

Vue.filter('toJson', function (value) {
    if (value) {
        return JSON.parse(value);
    }
});
// **********************************************************************************************************************

Vue.component('navbar-template', require('./components/includes/Sidenav.vue').default);
Vue.component('headnav-template', require('./components/includes/Headernav.vue').default);
Vue.component('breadcrumb-template', require('./components/includes/Breadcrumb.vue').default);
Vue.component('confirm-dialog', require('./components/includes/ConfirmDialog.vue').default);
Vue.component('user-account-template', require('./components/includes/UserAccount.vue').default);
Vue.component('bet-template', require('./components/Bet.vue').default);
Vue.component('player-autocomplete-template', require('./components/includes/PlayerAutocomplete.vue').default);
Vue.component('agent-autocomplete-template', require('./components/includes/AgentAutocomplete.vue').default);
Vue.component('agent-credit-autocomplete-template', require('./components/includes/AgentCreditAutocomplete.vue').default);

Vue.component('filter-dropdown-draw', require('./components/includes/FilterDraw.vue').default);
// **********************************************************************************************************************

import App from './App.vue'

Vue.config.devtools = true;
Vue.config.productionTip = false;

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes
});
// import APICONFIG from '/public/config.json';
// Vue.prototype.$baseapi = APICONFIG.API_BASE;
// Vue.prototype.$configapi = APICONFIG;


// Vue.prototype.$APICONFIG = (axios.get('config.json')).data;
// console.log(APICONFIG);
// window.APICONFIGS = (axios.get('config.json')).data;
// import APICONFIGS from '/public/config.json';



import YajraDT from "./yajra-datatable";
Vue.prototype.$YajraDT = YajraDT;

import Roles from './roles';
Vue.prototype.$role = new Roles(store, routes, router);
window.role = Vue.prototype.$role;

import InputRules from "./input-rules";
Vue.prototype.$inptrule = new InputRules();

import CONFIG from "./initialize";
import { initialize } from "./initialize";
Vue.prototype.$_CONFIG = CONFIG;
initialize(store, router, axios, CONFIG, toast_status);



var host = window.location.href;

var setPageTitle = null;
var currentLoginRoleBgClass = null;
var currentLoginRole = null;
var announcement = null;

if (host.includes("op")) {
    setPageTitle = "OPERATOR";
    currentLoginRole = 'operator';
    currentLoginRoleBgClass = 'set-background-operator';
    Vue.prototype.$LoginTitle = '<h3 class="text-white">OPERATOR</h3>';
    announcement = false;
}
else {
    setPageTitle = "AGENT";
    currentLoginRole = 'supervisor';
    currentLoginRoleBgClass = 'set-background-agent';
    Vue.prototype.$LoginTitle = '<h3 class="text-white">AGENT</h3>';
    announcement = true;
}

Vue.prototype.$filterLevels = [
    { text: 'Level 1', value: 1 },
    { text: 'Level 2', value: 2 },
    { text: 'Level 3', value: 3 },
    // { text: 'Level 4', value: 4 },
    // { text: 'Level 5', value: 5 },
    // { text: 'Level 6', value: 6 },
];

Vue.prototype.$agentName = "Agent";
Vue.prototype.$setPageTitle = setPageTitle;
Vue.prototype.$announcement = announcement;
Vue.prototype.$currentLoginRoleBgClass = currentLoginRoleBgClass;
Vue.prototype.$currentLoginRole = currentLoginRole;
Vue.prototype.$urladmin = "https://mgt.mrmsystem.live";


Vue.prototype.$setNameManagerSupervisor = function () {
    // DOWNLINE LABELS ON PAGE AND MODALS
    if (this.$store.state.currentUser.agent_data.level == 0) {
        return "Coordinator";
    } else if (this.$store.state.currentUser.agent_data.level == 1) {
        return "Agent";
    } else {
        return '';
    }
}

Vue.prototype.$levelNames = function (level) {
    if (level == 1) {
        return "Coordinator";
    } else if (level == 2) {
        return "Agent";
    } else {
        return "Operator";
    }
}

Vue.prototype.$hideifuserisSupervisor = function () {
    if (this.$store.state.currentUser.agent_data.level == 3) {
        return "d-none";
    }
}

router.beforeResolve((to, from, next) => {
    if (to.matched.some(route => route.meta.requiresAuth)) {
        const authUser = store.state.isLoggedIn;
        const isAuthFactorPass = store.state.isAuthFactorPass;
        const hasAuthFactor = store.state.hasAuthFactor;

        if (authUser) {
            axios.defaults.headers.common['Authorization'] = "Bearer " + store.state.currentUserToken;
        }

        if (authUser && isAuthFactorPass) {

            // IF ALREADY PASS TWOFACTOR REDIRECT FROM TWOFACTOR AUTHENTICATOR PAGE
            if (to.name == "two_factor_auth") {
                next({ path: '/' })
            } else {
                next()
            }

        } else if (authUser && hasAuthFactor && !isAuthFactorPass) { // IF SYSTEM IS TWOFACTOR ENABLED
            if (to.name == "two_factor_auth") {
                next();
            } else {
                next({ name: 'two_factor_auth' });
            }
        } else {
            next({ name: 'login' })
        }
    }


    if ((to.name == "login") && (store.state.isLoggedIn)) {
        next({ path: '/' })
    }

    next();

    if (window.location.href.includes("login") || window.location.href.includes("two-factor-auth")) {
        Vue.prototype.$isLoginPage = true;
    }
    else {
        Vue.prototype.$isLoginPage = false
    }
});
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = setPageTitle + " - " + to.meta.title
    }
    next();
})

new Vue({
    render: h => h(App),
    router,
    vuetify: new Vuetify(),
    store: store,
}).$mount('#app')



